import React, { useContext, useEffect } from "react";
import ProductContext from "../Context/productContext";
import OrderTable from "./OrderTable";

export default function Orders() {
  const context = useContext(ProductContext);
  const { orders, getOrders,markAsRead,markAsUnRead } = context;
  useEffect(() => {
    getOrders();
  }, []);

  return (
    <div
      className="modal fade"
      id="orderModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Orders
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
         {
           orders.map((item)=>{
             
             return( 
             <div>

             <OrderTable item={item} product={item.product} key={item.id} markAsRead={markAsRead} markAsUnRead={markAsUnRead}/>
             </div>
             )
           })
         }
          </div>
        </div>
      </div>
    </div>
  );
}
